(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omyae-composition"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('omyae-composition')) {
  customElements.define('omyae-composition', class extends HTMLElement {
    connectedCallback() {
      if (this.omChange) return;
      this.omChange = () => this.updateLayout();
      this.addEventListener('change', this.omChange);
      this.updateLayout();
      this.omResize = new ResizeObserver(() => this.updateLayout());
      this.omResize.observe(this.querySelector('[data-om-circles]'));
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.omChange);
      this.omChange = null;
      this.omResize?.disconnect();
    }
    updateLayout() {
      const count = Number(this.querySelector('[data-om-count]').value);
      const gap = Number(this.querySelector('[data-om-gap]').value);
      const rows = count / 3;
      this.querySelector('[data-om-width]').textContent = String(150 + 2 * gap);
      this.querySelector('[data-om-height]').textContent = String(rows * 50 + (rows - 1) * gap);
      const diagram = this.querySelector('[data-om-circles]');
      diagram.style.setProperty('--om-gap', String(gap / (150 + 2 * gap) * 100) + '%');
      diagram.style.rowGap = String(gap / (150 + 2 * gap) * diagram.clientWidth) + 'px';
      [...diagram.children].forEach((circle, index) => { circle.hidden = index >= count; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omyae-contact"] && !Shopify.designMode) return;
  try {
    
  function initOmyaeContact(root) {
    root.querySelectorAll('[data-omyae-contact]').forEach((container) => {
      const result = container.querySelector('[data-contact-result]');
      if (result) {
        result.focus({ preventScroll: true });
        result.scrollIntoView({ block: 'center' });
      }
      const form = container.querySelector('form');
      const pending = container.querySelector('[data-contact-pending]');
      if (!form || !pending || form.dataset.omyaeFeedbackBound) return;
      form.dataset.omyaeFeedbackBound = 'true';
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        pending.hidden = false;
        pending.focus({ preventScroll: true });
        pending.scrollIntoView({ block: 'center' });
      }, true);
      form.addEventListener('invalid', () => { pending.hidden = true; }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOmyaeContact(document), { once: true });
  } else {
    initOmyaeContact(document);
  }
  document.addEventListener('shopify:section:load', (event) => initOmyaeContact(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omyae-measure"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('omyae-measure')){customElements.define('omyae-measure',class extends HTMLElement{connectedCallback(){if(this.omClick)return;this.omClick=()=>{this.querySelector('details').open=true;document.documentElement.classList.add('om-print-checklist');window.addEventListener('afterprint',()=>document.documentElement.classList.remove('om-print-checklist'),{once:true});window.print();};this.querySelector('button').addEventListener('click',this.omClick);}disconnectedCallback(){this.querySelector('button')?.removeEventListener('click',this.omClick);this.omClick=null;document.documentElement.classList.remove('om-print-checklist');}});}

  } catch(e) { console.error(e); }
})();
})();
